import { COLOR_TAG_STYLES } from "@/config/constants";
import { IColorTag } from "../types/ColorTag";
import cn from "@/utils/class-names";

// Helper function to get color tag styles
export const getColorTagStyles = (colorTag?: IColorTag): string => {
  const colorTagName = colorTag?.name;

  if (!colorTagName || !COLOR_TAG_STYLES[colorTagName]) {
    return "";
  }

  const styles = COLOR_TAG_STYLES[colorTagName];
  return cn(styles.text, styles.bg, styles.border);
};
